import isConstant from "../isConstant";
import retrieveSchema from "./retrieveSchema";
/** Checks to see if the `schema` combination represents a select
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param theSchema - The schema for which check for a select flag is desired
 * @param [rootSchema] - The root schema, used to primarily to look up `$ref`s
 * @returns - True if schema contains a select, otherwise false
 */

export default function isSelect(validator, theSchema) {
  var rootSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var schema = retrieveSchema(validator, theSchema, rootSchema, undefined);
  var altSchemas = schema.oneOf || schema.anyOf;

  if (Array.isArray(schema.enum)) {
    return true;
  }

  if (Array.isArray(altSchemas)) {
    return altSchemas.every(function (altSchemas) {
      return typeof altSchemas !== 'boolean' && isConstant(altSchemas);
    });
  }

  return false;
}